import { ChangeEvent, CSSProperties, useEffect, useState } from "react";
import { Col, Form } from "react-bootstrap";

type AudioInputProps = {
  previewAudio: string;
  label: string;
  style?: CSSProperties | undefined;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
};

const AudioInput = ({
  previewAudio,
  label,
  style,
  onChange,
}: AudioInputProps) => {
  const [audioKey, setAudioKey] = useState<number>(0);

  useEffect(() => {
    // Quando o previewAudio muda, atualizamos a chave para forçar a recriação do componente de áudio
    setAudioKey(prev => prev + 1);
  }, [previewAudio]);

  return (
    <>
      <Form.Group
        as={Col}
        lg={previewAudio ? "3" : "6"}
        xs="12"
        className="mb-0 pt-2"
      >
        <Form.Label>{label}</Form.Label>
        <Form.Control
          type="file"
          onChange={onChange}
          accept=".mp3, .wav, .ogg"
          style={style}
        />
      </Form.Group>
      {previewAudio && (
        <Form.Group as={Col} lg="3" xs="12" className="mb-0 pt-2">
          <div
            style={{
              marginTop: "10px",
              borderWidth: 3,
              borderColor: "#ccc",
            }}
          >
            <audio key={audioKey} controls style={{ width: "100%" }} autoPlay={false}>
              <source src={previewAudio} />
              Seu navegador não suporta áudio.
            </audio>
          </div>
        </Form.Group>
      )}
    </>
  );
};

export default AudioInput;
